/**
 * @hide
 */
export default class ObjectRouteHandler {
  constructor(schema, serializerOrRegistry, object) {
    this.schema = schema;
    this.serializerOrRegistry = serializerOrRegistry;
    this.object = object;
  }

  handle(/* request */) {
    return this.object;
  }
}
